import Http from "./http";

export const updateTermsAndConditionsAPI = (payload, options) => {
  return Http.post("admin/campaign/terms-condition/update", payload, options);
};

